import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = `https://nc8.olharfixo.com.br/Vehicles/api/v3/groups`;
const basePathGroups = `https://nc8.olharfixo.com.br/Vehicles/api/v3/vehicles/groups`;


async function sendKmz(id, payload) {
	try {
		let response = await api.patch(`${basePath}/${id}/config/kmz`, JSON.stringify(payload));
		let treated = errorHandling.handleResponse(
			response,
			"vehicleGroupService.sendKmz"
		);
		if (treated) {
			return treated;
		}
		return null;

	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.sendKmz");
		return null;
	}
}

async function sendVisit(id, payload) {
	try {
		let response = await api.patch(`${basePath}/${id}/config/visit`, JSON.stringify(payload));
		let treated = errorHandling.handleResponse(
			response,
			"vehicleGroupService.sendVisit"
		);
		if (treated) {
			return treated;
		}
		return null;

	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.sendVisit");
		return null;
	}
}

async function sendFence(id, payload) {
	try {
		let response = await api.patch(`${basePath}/${id}/config/fence`, JSON.stringify(payload));
		let treated = errorHandling.handleResponse(
			response,
			"vehicleGroupService.sendFence"
		);
		if (treated) {
			return treated;
		}
		return null;

	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.sendFence");
		return null;
	}
}

async function sendRiskArea(id, payload) {
	try {
		let response = await api.patch(`${basePath}/${id}/config/risk-area`, JSON.stringify(payload));
		let treated = errorHandling.handleResponse(
			response,
			"vehicleGroupService.sendRiskArea"
		);
		if (treated) {
			return treated;
		}
		return null;

	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.sendRiskArea");
		return null;
	}
}

async function sendStreches(id, payload) {
	try {
		let response = await api.patch(`${basePath}/${id}/config/stretches`, JSON.stringify(payload));
		let treated = errorHandling.handleResponse(
			response,
			"vehicleGroupService.sendStreches"
		);
		if (treated) {
			return treated;
		}
		return null;

	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.sendStreches");
		return null;
	}
}

async function fetchGroupsConfigs(groupId) {
	try {
		let response = await api.get(`${basePathGroups}?groupId=${groupId}`);

		let treated = errorHandling.handleResponse(
			response,
			"vehicleGroupService.fetchGroupsConfigs"
		);
		if (treated) {
			return treated;
		}
		return null;

	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.fetchGroupsConfigs");
		return null;
	}
}







export const configsService = {
	sendKmz,
    sendFence,
    sendRiskArea,
    sendStreches,
    sendVisit,
	fetchGroupsConfigs
};
